import React from "react";
import { Outlet } from "react-router-dom";
import { MarketplaceThemeProvider } from "./MarketplaceTheme";
import MarketplaceHeader from "./MarketplaceHeader";
import MarketplaceFooter from "./MarketplaceFooter";
import MarketplaceSidebar from "./MarketplaceSidebar";

const MarketplaceLayout: React.FC = () => {
  return (
    <MarketplaceThemeProvider>
      <div style={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
        <MarketplaceHeader />
        <MarketplaceSidebar />
        <Outlet />
        <MarketplaceFooter />
      </div>
    </MarketplaceThemeProvider>
  );
};

export default MarketplaceLayout;
